import styles from "./FilterItem.module.scss";
import { Collapse } from "@mui/material";
import { useEffect, useState } from "react";
import { ChevronLeftOutlined } from "@mui/icons-material";
import classNames from "classnames";

const FilterItem = ({
  title,
  filterValue,
  icon,
  children,
  defaultOpen = false,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const totalValueApplied = !!filterValue
    ? Array.isArray(filterValue)
      ? filterValue.length
      : 1
    : 0;

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  return (
    <div
      className={classNames(styles["filter-item"], {
        [styles["open"]]: open,
      })}
    >
      <div
        className={styles["filter-item__title"]}
        onClick={() => setOpen(!open)}
      >
        <span className={styles["title--icon"]}>{icon}</span>
        <p className={styles["title"]}>{title}</p>
        {!!totalValueApplied && (
          <p className={styles["total-applied"]}>{totalValueApplied}</p>
        )}
        <ChevronLeftOutlined
          className={styles["filter-item__collapse--icon"]}
          style={{
            transform: open ? "rotate(-90deg)" : "rotate(90deg)",
          }}
        />
      </div>
      <Collapse in={open}>
        <div className={styles["filter-item__collapse"]}>{children}</div>
      </Collapse>
    </div>
  );
};

export default FilterItem;
